(function(angular) {
    angular.module('wtApp.wtTracking.errorHandler').factory('wtErrorPigeonInterceptor', wtErrorPigeonInterceptor);

    /**
     * @ngdoc service
     * @name wtErrorPigeonInterceptor
     * @description Interceptor that catches erroneous HTTP responses and logs them
     */
    wtErrorPigeonInterceptor.$inject = ['$injector'];
    function wtErrorPigeonInterceptor($injector) {
        const $q = $injector.get('$q');
        const wtErrorPigeon = $injector.get('wtErrorPigeon');
        const WtErrorHttp = $injector.get('WtErrorHttp');

        return {
            // requestError: function(rejection) {},

            /**
             * Webtrekk frontend logger for erroneous HTTP responses
             * @param {Object} rejection The previous interceptor rejection or error response
             * @returns {Promise}
             */
            responseError: function(rejection) {
                const status = rejection.status;
                const statusText = rejection.statusText;
                const url = rejection && rejection.config ? rejection.config.url : '';
                // When the remote endpoint provides the error description under the `message` property of the response
                const responseMessage = rejection && rejection.data && rejection.data.message ? rejection.data.message : statusText;
                // When the remote endpoint provides the error description under the `error` property of the response
                const responseError = rejection && rejection.data && rejection.data.error ? rejection.data.error : '';

                const message = `${responseMessage}`;

                wtErrorPigeon.sendException(
                    new WtErrorHttp(message, url, status, statusText), {status, statusText, responseMessage, responseError, url}
                );

                return $q.reject(rejection);
            }
        };
    }
})(window.angular);
